/** Canonical app routes (no /admin prefix). */

export const ROUTES = {
  login: "/login",
  signup: "/signup",
  join: "/join",
  branding: "/branding",
  switchWorkspace: "/switch-workspace",
  dashboard: "/dashboard",
  nexusChat: "/nexus/chat",
  portfolio: "/portfolio",
  engagement: "/engagement",
  studio: "/studio",
  reportProfiles: "/report-profiles",
  adminRoles: "/admin-console/roles",
  adminUsers: "/admin-console/users",
  adminEmailTemplates: "/admin-console/email-templates",
  adminAccess: "/admin-console/access",
  surveyTemplates: "/survey-templates",
};

export const LENS_ROUTES = {
  portfolioOperations: "/portfolio?lens=operations",
  portfolioPerformance: "/portfolio?lens=performance",
  engagementCompose: "/engagement?lens=compose",
  engagementPipeline: "/engagement?lens=pipeline",
  studioCompanies: "/studio?lens=companies",
  /** @deprecated Formats live inside Survey → New assessment; kept as alias */
  studioFormats: "/studio?lens=survey",
  studioSurvey: "/studio?lens=survey",
  studioReports: "/studio?lens=reports",
  studioKnowledge: "/studio?lens=knowledge",
};

export function normalizePath(pathname = "") {
  return String(pathname || "").split("?")[0].replace(/\/$/, "") || "";
}

export function isDashboardPath(pathname) {
  return normalizePath(pathname) === ROUTES.dashboard;
}

export function isNexusChatPath(pathname) {
  return normalizePath(pathname) === ROUTES.nexusChat;
}

/** Dashboard launcher + dedicated conversation — session persists across these routes. */
export function isNexusHomePath(pathname) {
  const path = normalizePath(pathname);
  return path === ROUTES.dashboard || path === ROUTES.nexusChat;
}
